import axios from "axios";
import {SharedDocument} from "@/api/sharedDocument";


interface ImageGalleryApi {
    listDocuments(): Promise<SharedDocument[]>;

    add(file: File): Promise<string>;

    renameDocument(sharedDocument: SharedDocument): Promise<void>;

    deleteDocument(sharedDocument: SharedDocument): Promise<void>;

    generateDownloadLink(sharedDocument: SharedDocument): string;
}

export const imageGalleryApi: ImageGalleryApi = {

    async listDocuments() {
        const result = (await axios.get(`/api/image-gallery`))
            .data as SharedDocument[];
        if (result) {
            return result.map(
                (v) =>
                    ({
                        ...v,
                        imageGallery: true,
                        uploadedAtUtc: v.uploadedAtUtc ? new Date(v.uploadedAtUtc) : null,
                    } as SharedDocument)
            );
        }
        return [];
    },

    async add(file) {
        const formData = new FormData();
        formData.append("file", file);
        return (await axios.post(`/api/image-gallery`, formData)).data;
    },

    async deleteDocument(sharedDocument) {
        return await axios.delete(`/api/image-gallery/${sharedDocument.documentRef}`);
    },

    generateDownloadLink(sharedDocument): string {
        return `/api/image-gallery/${sharedDocument.name}`;
    },

    async renameDocument(sharedDocument) {
        await axios.put(
            `/api/image-gallery/${sharedDocument.documentRef}`,
            sharedDocument,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
    },
};
